export const products = [
  {
    id: '1',
    name: 'Rubber Strap – For Rolex Datejust 41mm – Black',
    slug: 'rubber-strap-rolex-datejust-41mm-black',
    price: 100.00,
    category: 'watch-straps',
    categoryName: 'Rolex',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/deployant-strap-for-rolex-datejust-41mm-black-710179-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/deployant-strap-for-rolex-datejust-41mm-black-710179-300x225.webp'],
    description: 'Premium rubber strap designed specifically for the Rolex Datejust 41mm. Crafted from high-grade FKM rubber with a deployant clasp for secure wearing.',
    features: ['High-grade FKM rubber', 'Custom deployant clasp', 'Perfect fit for Datejust 41mm', 'Water-resistant'],
    inStock: true,
    featured: true
  },
  {
    id: '2',
    name: 'Rubber Strap – For Rolex Daytona – White',
    slug: 'rubber-strap-rolex-daytona-white',
    price: 100.00,
    category: 'watch-straps',
    categoryName: 'Rolex',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/deployant-rubber-strap-for-rolex-daytona-white-323174-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/deployant-rubber-strap-for-rolex-daytona-white-323174-300x225.webp'],
    description: 'Elegant white rubber strap crafted for the Rolex Daytona. Features a premium deployant buckle system for effortless wear.',
    features: ['Premium white FKM rubber', 'Deployant buckle system', 'Designed for Rolex Daytona', 'Hypoallergenic'],
    inStock: true,
    featured: true
  },
  {
    id: '3',
    name: 'Tripode Duo Green',
    slug: 'tripode-duo-green',
    price: 150.00,
    category: 'watch-accessories',
    categoryName: 'Watch Accessories',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/Remontoir-Montre-Tripode-Duo-Vert-1-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/Remontoir-Montre-Tripode-Duo-Vert-1-300x225.webp'],
    description: 'The Tripode Duo Green watch winder combines elegant design with precision engineering. Perfect for keeping your automatic watches wound and ready.',
    features: ['Dual watch capacity', 'Multiple rotation modes', 'Silent Japanese motor', 'Premium green finish'],
    inStock: true,
    featured: true
  },
  {
    id: '4',
    name: 'Ultra-Luxury Crocodile Leather Case – Dark Brown & Gold',
    slug: 'ultra-luxury-crocodile-leather-case',
    price: 500.00,
    category: 'phone-cases',
    categoryName: 'Phone Cases',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/IphoneCase-Lux_leather-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/IphoneCase-Lux_leather-300x225.webp'],
    description: 'Exquisite iPhone case crafted from genuine crocodile leather with 24K gold-plated accents. A statement piece for the discerning individual.',
    features: ['Genuine crocodile leather', '24K gold-plated details', 'Precision-cut for perfect fit', 'Luxury gift packaging'],
    inStock: true,
    featured: true
  },
  {
    id: '5',
    name: 'Picasso-Inspired Gold Edition iPhone Case',
    slug: 'picasso-inspired-gold-edition',
    price: 450.00,
    category: 'phone-cases',
    categoryName: 'Phone Cases',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/IphoneCase-Picaso-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/IphoneCase-Picaso-300x225.webp'],
    description: 'Art meets luxury in this Picasso-inspired iPhone case. Features intricate gold detailing on premium materials.',
    features: ['Artistic Picasso-inspired design', 'Gold edition detailing', 'Premium protective shell', 'Limited edition'],
    inStock: true,
    featured: true
  },
  {
    id: '6',
    name: 'Melkco Litchi Grain Leather Case',
    slug: 'melkco-litchi-grain-leather-case',
    price: 100.00,
    category: 'phone-cases',
    categoryName: 'Phone Cases',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/Sd5af1443604742d796c4c999646b2648Z.jpg_960x960q75.jpg_-300x225.webp',
    images: ['https://www.pass-lux.com/wp-content/uploads/2025/07/Sd5af1443604742d796c4c999646b2648Z.jpg_960x960q75.jpg_-300x225.webp'],
    description: 'Classic litchi grain leather case by Melkco. Combines elegant style with reliable protection for your iPhone.',
    features: ['Premium litchi grain leather', 'Slim profile design', 'Full port access', 'Microfiber interior lining'],
    inStock: true,
    featured: true
  },
  {
    id: '7',
    name: 'Ceramic Bezel Insert – Black GMT',
    slug: 'ceramic-bezel-insert-black-gmt',
    price: 85.00,
    category: 'watch-accessories',
    categoryName: 'Watch Accessories',
    image: 'https://images.unsplash.com/photo-1636289039346-ac54cc941975?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1636289039346-ac54cc941975?w=400&q=80'],
    description: 'High-quality ceramic bezel insert compatible with GMT Master II. Scratch-resistant with luminous markers.',
    features: ['Ceramic construction', 'Scratch-resistant surface', 'Luminous hour markers', 'Easy installation'],
    inStock: true,
    featured: false
  },
  {
    id: '8',
    name: 'Italian Calfskin Leather Strap – Tan',
    slug: 'italian-calfskin-leather-strap-tan',
    price: 120.00,
    category: 'watch-straps',
    categoryName: 'Watch Straps',
    image: 'https://images.unsplash.com/photo-1703355685913-0113173df436?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1703355685913-0113173df436?w=400&q=80'],
    description: 'Handcrafted Italian calfskin leather watch strap with hand-stitched edges. Develops a beautiful patina over time.',
    features: ['Italian calfskin leather', 'Hand-stitched edges', 'Quick-release spring bars', 'Available in 20mm and 22mm'],
    inStock: true,
    featured: false
  },
  {
    id: '9',
    name: 'Gold Chain Link Bracelet',
    slug: 'gold-chain-link-bracelet',
    price: 275.00,
    category: 'jewelry-accessories',
    categoryName: 'Jewelry Accessories',
    image: 'https://images.unsplash.com/photo-1765031069580-1ee9543c288f?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1765031069580-1ee9543c288f?w=400&q=80'],
    description: 'Elegant 18K gold-plated chain link bracelet. A timeless piece that complements any luxury timepiece.',
    features: ['18K gold plating', 'Adjustable clasp', 'Hypoallergenic', 'Gift box included'],
    inStock: true,
    featured: false
  },
  {
    id: '10',
    name: 'Watch Winder Box – Single Black',
    slug: 'watch-winder-box-single-black',
    price: 200.00,
    category: 'watch-accessories',
    categoryName: 'Watch Accessories',
    image: 'https://images.unsplash.com/photo-1636289141131-389e44e981c0?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1636289141131-389e44e981c0?w=400&q=80'],
    description: 'Single watch winder with matte black finish. Features multiple rotation settings and ultra-quiet motor.',
    features: ['Ultra-quiet Mabuchi motor', '4 rotation programs', 'Battery or AC powered', 'Piano black finish'],
    inStock: true,
    featured: false
  },
  {
    id: '11',
    name: 'Sapphire Crystal Caseback',
    slug: 'sapphire-crystal-caseback',
    price: 95.00,
    category: 'watch-accessories',
    categoryName: 'Watch Accessories',
    image: 'https://images.unsplash.com/photo-1636289026470-cb40ece1ebc3?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1636289026470-cb40ece1ebc3?w=400&q=80'],
    description: 'Exhibition sapphire crystal caseback. See the beauty of your movement with this scratch-resistant sapphire crystal.',
    features: ['Sapphire crystal', 'Anti-reflective coating', 'Gasket included', 'Professional installation recommended'],
    inStock: true,
    featured: false
  },
  {
    id: '12',
    name: 'Premium Jewelry Box – Walnut',
    slug: 'premium-jewelry-box-walnut',
    price: 350.00,
    category: 'jewelry-accessories',
    categoryName: 'Jewelry Accessories',
    image: 'https://images.unsplash.com/photo-1769116416641-e714b71851e8?w=400&q=80',
    images: ['https://images.unsplash.com/photo-1769116416641-e714b71851e8?w=400&q=80'],
    description: 'Handcrafted walnut jewelry box with velvet interior. Multiple compartments for watches, rings, and accessories.',
    features: ['Solid walnut wood', 'Velvet interior lining', 'Lock and key included', 'Multiple compartments'],
    inStock: true,
    featured: false
  }
];

export const categories = [
  {
    id: 'watch-accessories',
    name: 'Watch Accessories',
    slug: 'watch-accessories',
    description: 'Premium bezels, crowns and components',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/cat_box_watches.webp?auto=compress&cs=tinysrgb&w=600'
  },
  {
    id: 'watch-straps',
    name: 'Watch Straps',
    slug: 'watch-straps',
    description: 'Luxury leather and metal straps',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/cat_bracelets.webp?auto=compress&cs=tinysrgb&w=600'
  },
  {
    id: 'phone-cases',
    name: 'Phone Cases',
    slug: 'phone-cases',
    description: 'Elegant protection for your device',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/cat_cover_iphone-1.webp?auto=compress&cs=tinysrgb&w=600'
  },
  {
    id: 'jewelry-accessories',
    name: 'Jewelry Accessories',
    slug: 'jewelry-accessories',
    description: 'Exquisite jewelry components',
    image: 'https://www.pass-lux.com/wp-content/uploads/2025/07/cat_box_bijoux.webp?auto=compress&cs=tinysrgb&w=600'
  }
];

export const features = [
  {
    id: 1,
    icon: 'gem',
    title: 'Premium Quality',
    description: 'Handcrafted with the finest materials and attention to detail'
  },
  {
    id: 2,
    icon: 'shield',
    title: 'Lifetime Warranty',
    description: 'Every product backed by our comprehensive warranty'
  },
  {
    id: 3,
    icon: 'tag',
    title: 'No Hidden Fees',
    description: 'Love it or your money back — no questions asked'
  },
  {
    id: 4,
    icon: 'star',
    title: 'Exclusive Design',
    description: 'Limited edition pieces you won\'t find anywhere else'
  }
];

export const materials = [
  {
    id: 1,
    title: '316L Stainless Steel',
    description: 'Marine-grade stainless steel offering superior corrosion resistance and durability for everyday wear.'
  },
  {
    id: 2,
    title: 'Italian Leather',
    description: 'Hand-selected Italian calfskin leather, vegetable-tanned for exceptional softness and aging characteristics.'
  },
  {
    id: 3,
    title: 'Sapphire Crystal',
    description: 'Scratch-resistant sapphire crystal components providing ultimate clarity and protection for luxury timepieces.'
  }
];

export const mockOrders = [
  {
    id: 'ORD-001',
    customerName: 'James Wilson',
    customerEmail: 'james@example.com',
    items: [
      { productId: '1', name: 'Rubber Strap – For Rolex Datejust 41mm – Black', quantity: 1, price: 100.00 },
      { productId: '3', name: 'Tripode Duo Green', quantity: 1, price: 150.00 }
    ],
    total: 250.00,
    status: 'delivered',
    date: '2025-07-10',
    shippingAddress: '123 Bond Street, London, W1S 1PQ'
  },
  {
    id: 'ORD-002',
    customerName: 'Sophie Laurent',
    customerEmail: 'sophie@example.com',
    items: [
      { productId: '4', name: 'Ultra-Luxury Crocodile Leather Case', quantity: 1, price: 500.00 }
    ],
    total: 500.00,
    status: 'shipped',
    date: '2025-07-12',
    shippingAddress: '45 Avenue Montaigne, Paris 75008'
  },
  {
    id: 'ORD-003',
    customerName: 'Alexander Ross',
    customerEmail: 'alex@example.com',
    items: [
      { productId: '5', name: 'Picasso-Inspired Gold Edition iPhone Case', quantity: 1, price: 450.00 },
      { productId: '2', name: 'Rubber Strap – For Rolex Daytona – White', quantity: 2, price: 100.00 }
    ],
    total: 650.00,
    status: 'processing',
    date: '2025-07-14',
    shippingAddress: '78 Knightsbridge, London, SW1X 7RB'
  }
];
